/**
 * Theme scripts.
 */

import domReady from '@wordpress/dom-ready';

domReady( () => {
	/**
	 * Randomize the delay of all elements on the page with a float utility
	 * class using CSS custom properties.
	 */
	const floatElements = document.querySelectorAll( '.float, .float-sm' );

	floatElements.forEach( ( element ) => {
		const random = Math.random() * 2;
		element.style.setProperty( '--float-delay', `-${ random }s` );
	} );
} );
